import { forwardRef, Ref } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link, NavLink } from 'react-router-dom';

import { AppPath } from 'utils/url/appPaths';
import { AppUrlOptions } from 'utils/url/createAppUrl';

import { LinkProps, NavLinkProps } from './appLink.types';
import { createTo } from './utils/createTo';

/**
 * A component that wraps the native react-router-dom <Link> component with a
 * strongly typed interface.
 */
export const AppLink = forwardRef(function AppLink<TAppPath extends AppPath>(
  options: AppUrlOptions<TAppPath> & LinkProps,
  ref: Ref<HTMLAnchorElement>,
): JSX.Element {
  return (
    <Link {...options} ref={ref} to={createTo(options)}>
      {options.children}
    </Link>
  );
});

/**
 * A component that wraps the native react-router-dom <NavLink> component with a
 * strongly typed interface.
 */
export const AppNavLink = forwardRef(function AppNavLink<
  TAppPath extends AppPath,
>(
  options: AppUrlOptions<TAppPath> & NavLinkProps,
  ref: Ref<HTMLAnchorElement>,
): JSX.Element {
  return (
    <NavLink {...options} ref={ref} to={createTo(options)}>
      {options.children}
    </NavLink>
  );
});
